'use strict';

angular.module('userRequestEditControllers')

.controller('NavigateBusinessTaskController', ['$scope', function ($scope) {

    // Update Navigation
    var updateNavivation = function () {

        var withSearch = $scope.ctxSearchBusinessTask.withSearch();

        var filterOnSearchBusinessTaskIDs = function (taskInSearch) {
            if (withSearch !== true) return true;

            return _.findIndex($scope.ctxSearchBusinessTask.businessTasks,
                               function (task) {
                                   return task.BusinessTaskID === taskInSearch.BusinessTaskID;
                               }) !== -1;
        }

        var filteredTasks = _.chain($scope.businessTasks)
                             .filter(filterOnSearchBusinessTaskIDs)
                             .value();
        var indexCurrentCase = _.findIndex(filteredTasks,
                                           function (task) {
                                               return task.BusinessTaskID === $scope.businessTask.BusinessTaskID;
                                           });

        if (indexCurrentCase === -1) {
            $scope.prevBusinessTask = null;
            $scope.nextBusinessTask = null;
        }
        else {
            if (indexCurrentCase === 0) $scope.prevBusinessTask = null;
            else $scope.prevBusinessTask = filteredTasks[indexCurrentCase - 1];

            if (indexCurrentCase === (filteredTasks.length - 1)) $scope.nextBusinessTask = null;
            else $scope.nextBusinessTask = filteredTasks[indexCurrentCase + 1];
        }
    }

    $scope.$watch('ctxSearchBusinessTask.businessTasks', function (newValue) { updateNavivation(); }, true);
}]);